import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import CheckoutFormHOC from '../shared/CheckoutFormHOC';
import PackageContent from '../shared/PackageContent';
import PackageExtras from '../shared/PackageExtras';
import SafePureComponent from '../shared/SafePureComponent';
import { getPackageById, getSingleCalculator } from '../../reducers/packages';
import { shouldShowSelectPackage } from '../../utils/shouldShowSelectPackage';
import { BASIC_PACKAGE_ID } from '../../utils/packagesUtils/constants';
import GigQuantity from './GigQuantity';

import './style.scss';

const OrderDetails = (
    { currentPrice, inProgress, calculator },
    { general, currencyConverter }
) => {

    const formattedPrice = currencyConverter.convert(currentPrice);
    const showSelectPackage = shouldShowSelectPackage(general);
    const buttonClassName = classNames('btn-lrg-standard', {'in-progress': inProgress});

    return (
        <div className="order-details">
            <h2 className="section-title"><I18n k={'gig_page_perseus.packages.order_details'}/></h2>
            <div className="content">
                <PackageContent id={BASIC_PACKAGE_ID} showPrice={false}/>
                {!calculator &&
                    <GigQuantity/>
                }
                <PackageExtras/>
                {showSelectPackage &&
                <div className="button-wrapper">
                    <button type="submit" className={buttonClassName}><I18n k={'gig_page_perseus.packages.continue'}/>
                        <span> ({formattedPrice})</span>
                    </button>
                </div>
                }
            </div>
        </div>
    );
};

OrderDetails.defaultProps = {
    inProgress: false
};

OrderDetails.propTypes = {
    currentPrice: PropTypes.number,
    inProgress: PropTypes.bool,
    calculator: PropTypes.object
};

OrderDetails.contextTypes = {
    general: PropTypes.object,
    currencyConverter: PropTypes.object
};

const mapStateToProps = ({ packages }) => {
    const { currentPrice, inProgress } = getPackageById(packages, BASIC_PACKAGE_ID);
    const calculator = getSingleCalculator(packages, BASIC_PACKAGE_ID);

    return {
        currentPrice,
        inProgress,
        calculator
    };
};

const OrderDetailsConnect = connect(mapStateToProps)(OrderDetails);

const OrderDetailsWrapper = () => (
    <CheckoutFormHOC selectedPackageId={BASIC_PACKAGE_ID} source="Bottom Main">
        <OrderDetailsConnect/>
    </CheckoutFormHOC>
);

export { OrderDetailsWrapper, OrderDetails };
export default SafePureComponent(OrderDetailsWrapper);
